var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$store.getters.auth.isAuth && _vm.$store.state.init_state)?_c('div',[_c('APPNavbar',{staticClass:"no-print"}),_c('v-main',[_c('router-view',{staticClass:"mx-2"})],1)],1):(_vm.$store.state.init_state)?_c('div',[_c('v-main',[_c('router-view')],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }